<script setup lang="ts">
import moment from 'moment'
import DateTimeFormated from '@/onenetwork/components/datetime/DateTimeFormated.vue'

interface Props {
  data: Date | string ,
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <div :class="`table-cell datetime-cell ${props.cellConfig.class || ''}`">
    <template v-if="props.data">
      <date-time-formated :value="props.data"/>
    </template>
    <template v-else>
      --
    </template>
  </div>
</template>

<style scoped>

</style>
